exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"small-viewport": "(max-width: 30em)",
	"medium-viewport": "(max-width: 768px)",
	"large-viewport": "(min-width: 769px) and (max-width: 1400px)",
	"xtra-large-viewport": "(min-width: 1401px)"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/styles/mediaQueries.css
// module id = 1672
// module chunks = 23